var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voucher"},[_c('cp-field',{staticClass:"voucher__code",attrs:{"label":"Voucher","for":"voucher__code","id":"voucher__code","type":"text","name":"voucher__code","placeholder":"Insira o número do voucher","mask":['XXXXXXXXXX'],"value":_vm.code,"validation":_vm.checkCode},on:{"change":_vm.setCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }